// extracted by mini-css-extract-plugin
export var baseButton = "_r7-0";
export var controlsArrowKeys = "_r7-1";
export var controlsResetButton = "_r7-2";
export var lightGameButton = "_r7-4 _r7-0";
export var playAgainButton = "_r7-5 _r7-0";
export var startGameButton = "_r7-3 _r7-0";